<template>
    <v-container fluid class="pa-5">

        <v-row align="center">
            <v-col v-for="(image, index) in images" :key="image.pathShort"
                   cols="12" sm="12" md="6" lg="6" xl="6"
                   :class="random(index)">
                <v-img
                        :src="image.pathLong"
                        :lazy-src="imagesMin[index].pathLong"
                >
                    <template v-slot:placeholder>
                        <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                        >
                            <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                            ></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

    export default {
        name: "ADV2024",

        data: () => ({
            images: [],
            imagesMin: [],
            indexes: [0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1],
        }),

        created() {
            this.importImages(require.context('../assets/advs/adv_2024/', true, /\.jpg$/));
            this.importImagesMin(require.context('../assets/advs/adv_2024_min/', true, /\.jpg$/));
        },

        methods:{
            importImages(r) {
                console.log(r);
                r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key })));
            },

            importImagesMin(r) {
                console.log(r);
                r.keys().forEach(key => (this.imagesMin.push({ pathLong: r(key), pathShort: key })));
            },

            random(index) {
                if(this.isMobile()){
                    if (index % 2 === 0){
                        return "pa-10"
                    } else if (index % 3 === 0){
                        return "py-10 px-5"
                    }
                    else return "pa-0"
                } else {
                    if (this.indexes[index] === 1){
                        return "pa-5"
                    } else {
                        return "pa-0"
                    }
                }
            },
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
        }
    }
</script>

<style scoped>

</style>